import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { useWorkspace } from "./WorkspaceContext";

const Ctx = createContext(null);

export function GoalsProvider({ children }) {
  const { current } = useWorkspace() || {};
  const [goals, setGoals] = useState([]);

  const load = useCallback(async () => {
    if (!current?.workspace_id) return;
    try {
      const { data } = await api.get(`/workspaces/${current.workspace_id}/goals`);
      setGoals(data || []);
    } catch {}
  }, [current?.workspace_id]);

  useEffect(() => { load(); }, [load]);

  const create = async (body) => {
    const { data } = await api.post(`/workspaces/${current.workspace_id}/goals`, body);
    setGoals(g => [...g, data]);
    return data;
  };
  const update = async (goal_id, patch) => {
    await api.put(`/workspaces/${current.workspace_id}/goals/${goal_id}`, patch);
    setGoals(g => g.map(x => x.goal_id === goal_id ? { ...x, ...patch } : x));
  };
  const remove = async (goal_id) => {
    await api.delete(`/workspaces/${current.workspace_id}/goals/${goal_id}`);
    setGoals(g => g.filter(x => x.goal_id !== goal_id));
  };

  return <Ctx.Provider value={{ goals, create, update, remove, reload: load }}>{children}</Ctx.Provider>;
}

export const useGoals = () => useContext(Ctx);
